// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S-59","tabsBox":"styles_tabsBox__m8GvL","createButton":"styles_createButton__9ca3C"};